import React, { useState, useEffect, useRef } from 'react';
import { API } from 'aws-amplify';
import './FollowTheBeatModule9.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PopUp from '../Popup/logoutPopup';
import { getVideo } from '../s3Func/s3Download';
import LottieAnimation from '../components/Lottie/LottieAnimation';
import left from './left_hand.svg'
import right from './right_hand.svg'
import loading from './../loading-gif-png-5.gif';

const FollowTheBeatModule9 = (props) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const lottieRef = useRef()
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const monkey = generateImageUrl('images/Module4Images/Monkey+Practice+still.gif')
  const satyr = generateImageUrl('images/Module9Images/DailyReward_Sytar2.png')
  const bananaPile = generateImageUrl('images/Module9Images/Unit2_Mod4_PileofBananas@2x.png')
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png')
  const coin = generateImageUrl('images/Images/Coin_Empty.png')
  
  const [playInstructions, setPlayInstructions] = useState(false);
  const [monkeyStatemonkeyState, setMonkeyState] = useState(monkey);
  const [playSong, setPlaySong] = useState(false);
  const [song, setSong] = useState(props.song);
  const [playAwesomeJob, setPlayAwesomeJob] = useState(false);

  const [coinAnimationState, setCoinAnimationState] = useState('');
  const [showCoin, setShowCoin] = useState(false);

  const [CountingGif, setCountingGif] = useState(props.count);
  const [counting, setCounting] = useState(false);

  const [awesomeJobAudio, setAwesomeJobAudio] = useState('');
  const [awesomeJobGIF, setAwesomeJobGIF] = useState(props.awesomeJob);
  const [showAnimal, setShowAnimal] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [score, setScore] = useState(0);


  const [isOpen, setIsOpen] = useState(false);
  const [tutorial, setTutorial] = useState(props.tutorial1);

  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  // Music audio refs/state
  const musicAudioRef = useRef(null);
  const expectedMusicSrcRef = useRef('');
  const musicEndActionRef = useRef(null);
  const musicOnPlayActionRef = useRef(null);
  const [musicSrc, setMusicSrc] = useState('');
  const [musicShouldPlay, setMusicShouldPlay] = useState(false);

  // Starts the application
  useEffect(() => {
    setAwesomeJobAudio(getVideo('appfiles/respond/respond_amazing_job.mp3', login));
    setAwesomeJobGIF(getVideo('appfiles/respond/respond_amazing_job.gif', login));
    controllerStart();
  }, []);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Helper to programmatically play music audio
  const playMusicAudio = async (src, onEndedAction = null, onPlayAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') src = await src;
    const el = musicAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedMusicSrcRef.current = src;
    musicEndActionRef.current = onEndedAction;
    musicOnPlayActionRef.current = onPlayAction;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setMusicSrc(src);
      setMusicShouldPlay(true);
    }
  };

  const timing = [
    {
      timestamp: 0,
    },
    {
      timestamp: 3.9,
    },
    {
      timestamp: 5.95,
    },
    {
      timestamp: 7.25,
    },
    {
      timestamp: 8.63,
    },
    {
      timestamp: 9.23,
    },
    {
      timestamp: 11.28,
    },
    {
      timestamp: 12.58,
    },
    {
      timestamp: 13.96,
    },
    {
      timestamp: 14.56,
    },
    {
      timestamp: 16.61,
    },
    {
      timestamp: 17.91,
    },
    {
      timestamp: 19.29,
    },
    {
      timestamp: 19.89,
    },
    {
      timestamp: 21.94,
    },
    {
      timestamp: 23.24,
    },
    {
      timestamp: 24.62,
    },
    {
      timestamp: 25.22,
    },
    {
      timestamp: 27.27,
    },
    {
      timestamp: 28.57,
    },
    {
      timestamp: 29.95,
    },
    {
      timestamp: 30.55,
    },
    {
      timestamp: 32.6,
    },
    {
      timestamp: 33.9,
    },
    {
      timestamp: 35.28,
    },
    {
      timestamp: 35.88,
    },
    {
      timestamp: 37.93,
    },
    {
      timestamp: 39.23,
    },
    {
      timestamp: 40.61,
    },
    {
      timestamp: 41.21,
    },
    {
      timestamp: 43.26,
    },
    {
      timestamp: 44.56,
    },
    {
      timestamp: 45.94,
    },
    {
      timestamp: 46.54,
    },
    {
      timestamp: 48.59,
    },
    {
      timestamp: 49.89,
    },
    {
      timestamp: 51.27,
    },
    {
      timestamp: 51.87,
    },
    {
      timestamp: 53.92,
    },
    {
      timestamp: 55.22,
    },
    {
      timestamp: 56.6,
    },
  ];

  const [context, setContext] = useState({
    circleCount: 1,
    timingCount: 0,
    activateClickDiv: false,
    clickedOnce: false,
    showCircle1: false,
    showCircle2: false,
    showCircle3: false,
    showCircle4: false,
    timerId: 0,
    secondTimerId: 0,
    startedTutorial: false,
    finishedTutorial: false,
    startedTutorial2: false,
    finishedTutorial2: false,
  });

  // Play tutorial (music channel) when startedTutorial is set
  useEffect(() => {
    if (!context.startedTutorial) return;
    playMusicAudio(
      tutorial,
      () => {
        document.getElementsByClassName(
          'circleBananaDiv'
        )[0].style.display = 'none';
        context.secondTimerId = setTimeout(() => {
          context.activateClickDiv = true;
          context.clickedOnce = false;
          setContext({ ...context });
        }, 1000);
        if (props.unit4){
          if(tutorial !== props.tutorial1_2){
            document.getElementById('rightHand').style.display =
            'block';
          }
          else{
            document.getElementById('leftHand').style.display =
            'block';
          }
        }
        document.getElementsByClassName(
          'circleBananaDiv'
        )[0].style.display = 'block';
        context.startedTutorial = false;
        setContext({ ...context });
      }
    );
  }, [context.startedTutorial, tutorial]);

  // Play tutorial2 (music channel) when startedTutorial2 is set
  useEffect(() => {
    if (!context.startedTutorial2) return;
    playMusicAudio(
      props.tutorial2,
      () => {
        setPlaySong(true);
      }
    );
  }, [context.startedTutorial2, props.tutorial2]);

  // Play main song (music channel) when playSong is toggled
  useEffect(() => {
    if (!playSong) return;
    playMusicAudio(
      song,
      () => {
        setPlaySong(false);
        setCounting(false);
        if (context.finishedTutorial) {
          if(props.unit3 || props.unit4){
            document.getElementsByClassName('circleBananaDiv')[0].style.display = 'none';
            document.getElementById('rightHand').style.display = 'none';
            document.getElementById('leftHand').style.display = 'none';
          }
          setAnimalVoice(awesomeJobAudio);
          setMonkeyState(awesomeJobGIF);
          setShowAnimal(true);
          setPlayAwesomeJob(true);
        } else {
          togglePopup();
          document.getElementsByClassName('circleBananaDiv')[0].style.display = 'none';
          document.getElementsByClassName('circleBananaDiv')[1].style.display = 'none';
          document.getElementsByClassName('circleBananaDiv')[2].style.display = 'none';
          document.getElementsByClassName('circleBananaDiv')[3].style.display = 'none';
          context.finishedTutorial = true;
          setContext({ ...context });
        }
      },
      () => {
        context.finishedTutorial ? StartFTB() : props.unit4 ? ftbTutorial2() : ftbTutorial();
      }
    );
  }, [playSong, song]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 10 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  async function StartFTB() {
    let count = 0;
    let round = 1;
    for (let i = 1; i < timing.length; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      setCounting(false);
      setCountingGif(null);
      await sleep(1);
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleBananaDiv')[3].style.display =
            'none';
        }, 1000);
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleBananaDiv')[
          count - 1
        ].style.display = 'none';
      }
      if (count === 0) {
        if((round % 2) !== 0 && props.unit4){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else if ((round % 2) === 0 && props.unit4){
          document.getElementById('leftHand').style.display =
          'block';
        }
        //500
        document.getElementsByClassName('circleBananaDiv')[0].style.display = 'block';
        setTimeout(() => {
          if(!props.unit3 && !props.unit4) {
            setCountingGif(props.count)
            setCounting(true);
          }
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 900); //1400
      } else {
        document.getElementsByClassName('circleBananaDiv')[
          count
        ].style.display = 'block';
        if(!props.unit3 && !props.unit4) {
          setTimeout(() => {
            setCountingGif(props.count)
            setCounting(true);
          }, 500);
        }
        else{
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 500);
        }
      }
      count += 1;
      if (count === 4) {
        round += 1;
        count = 0;
      }
    }
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleBananaDiv')[3].style.display =
      'none';
  }

  function increaseCoins() {
    props.module.coins++;
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
  };

  async function ftbTutorial() {
    let count = 0;
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleBananaDiv')[3].style.display =
            'none';
        }, 1000);
      } else {
        if (count === 1) {
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleBananaDiv')[
          count - 1
        ].style.display = 'none';
      }
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleBananaDiv')[0].style.display =
            'block';
        }, 500);
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 1400);
      } else if (count === 3) {
        document.getElementsByClassName('circleBananaDiv')[
          count
        ].style.display = 'block';
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 500);
        }
      } else {
        document.getElementsByClassName('circleBananaDiv')[
          count
        ].style.display = 'block';
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 500);
        }
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
  }

  async function ftbTutorial2() {
    let count = 0;
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleBananaDiv')[3].style.display =
            'none';
        }, 1000);
      } else {
        if (count === 1) {
          document.getElementById('rightHand').style.display =
          'none';
          document.getElementById('leftHand').style.display =
          'none';
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleBananaDiv')[
          count - 1
        ].style.display = 'none';
      }
      if (count === 0) {
        if(i === 1){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else{
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          document.getElementsByClassName('circleBananaDiv')[0].style.display =
            'block';
        }, 500);
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 1400);
      } else if (count === 3) {
        document.getElementsByClassName('circleBananaDiv')[
          count
        ].style.display = 'block';
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 500);
        }
      } else {
        document.getElementsByClassName('circleBananaDiv')[
          count
        ].style.display = 'block';
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 500);
        }
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
  }

  // Initially starts FTB with or without the tutorial based on what day we're at
  function controllerStart() {
    if (props.module.unlockedDays.day2 || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      setPlayInstructions(true);
      setAnimalVoice(props.instruction);
      setMonkeyState(props.instructionGIF);
      setShowAnimal(true);
      context.finishedTutorial = true;
      setContext({ ...context });
    } else {
      setSong(props.walkthrough);
      context.startedTutorial = true;
      setContext({ ...context });
    }
  }

  async function leftrightHands(){
    document.getElementById('pattingSatyr').style.display='block'
    if(tutorial !== props.tutorial1_2){
      document.getElementById('rightHand').style.display =
      'none';
    }
    else{
      document.getElementById('leftHand').style.display =
      'none';
    }
    document.getElementsByClassName('circleBananaDiv')[1].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 1.5 * 1000));
    document.getElementsByClassName('circleBananaDiv')[1].style.display =
    'none';
    document.getElementsByClassName('circleBananaDiv')[2].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 1.5 * 1000));
    document.getElementsByClassName('circleBananaDiv')[2].style.display =
    'none';
    document.getElementsByClassName('circleBananaDiv')[3].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 1.5 * 1000));
    document.getElementsByClassName('circleBananaDiv')[3].style.display =
    'none';
    if(tutorial !== props.tutorial1_2){
      setTutorial(props.tutorial1_2)
      context.startedTutorial = true;
      setContext({ ...context });
    }
    else{
      context.startedTutorial2 = true;
      setContext({ ...context });
    }
  }

  // A function that should be removed when the app is deployed, this allows us
  // as devs to skip the entirity of FTB.
  function SkipBubbles() {
    setPlaySong(false);
    if (!props.module.reviewIcon) {
      dispatch({ type: props.stepComplete, payload: 'followthebeat' });
    }
    props.setDisplayFTB(false);
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <>
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (playInstructions) {
              setPlayInstructions(false);
              setPlaySong(true);
            }
            if (playAwesomeJob) {
              updateScore();
              if (!props.module.reviewIcon) {
                dispatch({
                  type: props.stepComplete,
                  payload: 'followthebeat',
                });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayFTB(false);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      <div
        id='FollowTheBeatBody9'
        style={{
          backgroundImage: `url(${
            generateImageUrl('images/Module9Images/FTB%20Module%209-1.png')
          })`,
        }}
      >
        {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false ) && <button type='button' onClick={SkipBubbles}>
          Skip The Bubbles
        </button>}
        {isOpen && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Ready to begin playing?
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    setCounting(false);
                    togglePopup();
                    setSong(props.song);
                    setPlaySong(true);
                    context.finishedTutorial = true;
                    setContext({ ...context });
                  }}
                >
                  START
                </button>
              </>
            }
            handleClose={togglePopup}
          />
        )}

        <div className='scoreBar'>
          <img className='scoreKey' src={coinBar} alt='monkey Icon' />
          {props.module.coins < 10 && (
            <h5 className='scoretext1'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 10 && props.module.coins < 100 && (
            <h5 className='scoretext10'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 100 && (
            <h5 className='scoretext100'>{props.module.coins}</h5>
          )}
          <p className='scoretext'>100</p>
        </div>

        {showCoin && (
          <img
            id={coinAnimationState}
            className='chooseReward'
            src={coin}
            alt='reward key'
            style={{
              position: 'absolute',
              top: '40vh',
              left: '50vw',
              width: '100px',
              height: '100px',
              marginLeft: '-50px',
              marginTop: '-50px',
            }}
            onClick={() => {
              coinAnimation();
            }}
          ></img>
        )}

        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayFTB(false);
          }}
        ></img>

        {(props.unit3 || props.unit4) && <div id='pattingSatyr'>
          <LottieAnimation
            ref={lottieRef}
            jsonUrl="appfiles/solutions/Satyr Patting.json"
            onAnimationComplete={() => console.log('completed')}
            unit1={true}
            login={login}

          />
        </div>}
        
        <img className='animateMonkeyFollow' src={monkey} alt='monkey Icon' />
        {showAnimal && !audioReady && <img id='loading' src={loading} />}
        {showAnimal && (
          <img
            className='animateMonkeyFollow'
            style={audioReady ? {} : { display: 'none' }}
            src={monkeyStatemonkeyState}
            onLoad={() => {
              setDisplayVoice(true);
            }}
            onError={() => setShowAnimal(false)}
          />
        )}
        {!isOpen && (
          <img
            className='animateMonkeyFollow'
            src={CountingGif}
            style={counting ? { display: 'block' } : { display: 'none' }}
          />
        )}
        {(!props.unit3 && !props.unit4) && <img className='animateSatyr' src={satyr} alt='satyr Icon' />}
        <img className='bananaPile' src={bananaPile} alt='banana Pile Icon' />

        <div id='clickCircle' />
        <img src={left} id='leftHand' alt='left hand'/>
        <img src={right} id='rightHand' alt='right hand'/>
        {context.activateClickDiv ? (
          <div
            id='timedCircle'
            onClick={function () {
              if (context.finishedTutorial) {setScore(score + 1);}
              if (context.finishedTutorial || context.startedTutorial2) {
                setCoinAnimationState('coinAnimation');
                setShowCoin(true);
                sleep(1000).then(() => {
                  setShowCoin(false);
                  increaseCoins();
                  setCoinAnimationState('');
                });
              } else {
                context.activateClickDiv = false;
                if (props.unit4){
                  leftrightHands();
                }
                else{
                  context.startedTutorial2 = true;
                }
                document.getElementsByClassName(
                  'circleBananaDiv'
                )[0].style.display = 'none';
                setContext({ ...context });
              }
              context.activateClickDiv = false;
              setContext({ ...context });
            }}
          role='button'></div>
        ) : (
          <></>
        )}
        <div
          id='circleBanana1'
          className='circleBananaDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module9Images/Unit2_Mod4_FTB_Yellow_Banana@2x.png')
            })`,
          }}
        >
          <p className='bananaText'>1</p>
        </div>
        <div
          id='circleBanana2'
          className='circleBananaDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module9Images/Unit2_Mod4_FTB_Green_Banana@2x.png')
            })`,
          }}
        >
          <p className='bananaText'>2</p>
        </div>
        <div
          id='circleBanana3'
          className='circleBananaDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module9Images/Unit2_Mod4_FTB_Green_Banana@2x.png')
            })`,
          }}
        >
          <p className='bananaText'>3</p>
        </div>
        <div
          id='circleBanana4'
          className='circleBananaDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module9Images/Unit2_Mod4_FTB_Green_Banana@2x.png')
            })`,
          }}
        >
          <p className='bananaText'>4</p>
        </div>
      </div>
      <audio
        ref={musicAudioRef}
        src={musicSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = musicAudioRef.current;
          if (!el) return;
          if (!musicShouldPlay) return;
          el.currentTime = 0;
          el.play().then(() => {
            const onPlayAction = musicOnPlayActionRef.current;
            if (typeof onPlayAction === 'function') onPlayAction();
          }).catch(() => {});
        }}
        onEnded={() => {
          const action = musicEndActionRef.current;
          musicEndActionRef.current = null;
          setMusicShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
    </>
  );
};
export default FollowTheBeatModule9;
